import { DIALOG_DATA } from '@angular/cdk/dialog';

import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-text-input-dialog',
  imports: [
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    TranslateModule,
  ],
  templateUrl: './text-input-dialog.component.html',
  styleUrl: './text-input-dialog.component.scss',
})
export class TextInputDialogComponent {
  private dialogRef = inject(MatDialogRef<string>);

  dialogData: {
    text?: string;
    value?: string;
  } = inject(DIALOG_DATA);

  readonly input = new FormControl<string>('');

  constructor() {
    if (this.dialogData?.value) {
      this.input.patchValue(this.dialogData.value);
    }
  }

  onClose(): void {
    this.dialogRef.close(null);
  }

  onSave(): void {
    this.dialogRef.close(this.input.value);
  }
}
